import { render, staticRenderFns } from "./studyArea.vue?vue&type=template&id=91dc2662&scoped=true&"
import script from "./studyArea.vue?vue&type=script&lang=js&"
export * from "./studyArea.vue?vue&type=script&lang=js&"
import style0 from "./studyArea.vue?vue&type=style&index=0&id=91dc2662&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91dc2662",
  null
  
)

export default component.exports